namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pme = Portico.Models.Enterprise;
    import psga = apigateway.client;
    import psgm = apigateway.models;

    export interface IMiscService {
        janssenGECheck: (janssenGECheckRequestModel: pme.JanssenGECheck) => angular.IPromise<psgm.JanssenGECheckResponseModel>;
    }

    @Service('app', 'miscService')
    @Inject('$q', 'EdgeTempApi')
    export class MiscService implements IMiscService {
        constructor(
            private $q: angular.IQService,
            private edgeTempApi: psga.EdgeTempApi
        ) {}

        janssenGECheck(janssenGECheckRequestModel: pme.JanssenGECheck) {
            const requestModel: psgm.JanssenGECheckRequestModel = {
                tcProgramId: janssenGECheckRequestModel.tcProgramId,
                ndc: janssenGECheckRequestModel.ndc,
                patient: {
                    firstName: janssenGECheckRequestModel.firstName,
                    lastName: janssenGECheckRequestModel.lastName,
                    gender: janssenGECheckRequestModel.gender,
                    dateOfBirth: janssenGECheckRequestModel.dateOfBirth,
                    addressLine1: janssenGECheckRequestModel.addressLine1,
                    city: janssenGECheckRequestModel.city,
                    state: janssenGECheckRequestModel.state,
                    zipCode: janssenGECheckRequestModel.zipCode,
                },
                uniqueId: janssenGECheckRequestModel.uniqueId,
                memberNumber:janssenGECheckRequestModel.memberNumber
            };

            return this.$q.when(this.edgeTempApi.tempJanssenGeCheck(requestModel).then((response) => {
                return response.data.data;
            }));
        }
    }
}